export const imageWH = '168px'

export const professionPath = '/prof'
